
<p class="carousel-grid--label">Which experiences do you enjoy?</p>
<poi-select-carousel selectedFilter="experience"></poi-select-carousel>

<p class="carousel-grid--label">Whats your Travel Style?</p>
<poi-select-carousel selectedFilter="travelStyle"></poi-select-carousel>

<p class="carousel-grid--label">What are your favorite Activities?</p>
<poi-select-carousel selectedFilter="activity"></poi-select-carousel>
